import { Form, Row, Col, InputNumber, Input, Button, Table, Typography, Select } from "antd";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

const { Text } = Typography;

export default function CurrencySummary({
  form,
  currencyOptions,
  summaryEntries,
  setSummaryEntries,
}) {
  const handleAddSummary = () => {
    const values = form.getFieldsValue();
    const { currencySummary, shortage, overage, reason } = values;
    console.log(shortage, "shortage");
    console.log(overage, "overage");
    console.log(reason, "reason");

    if (String(shortage).trim() && String(overage).trim() && reason) {
      // console.log(currencySummary, "currencySummary");
      // const existingEntry = summaryEntries.find(
      //   (e) => e.currencySummary.toLowerCase() === currencySummary.toLowerCase(),
      // );
      // if (existingEntry) {
      //   BOM.AlertMsg(cnt.DANGER, "Currency already exists");
      //   return;
      // }
      const newEntry = {
        key: Date.now(),
        currencySummary: currencyOptions.find((c) => c.value === currencySummary)?.label,
        shortage: shortage,
        overage: overage,
        reason: reason,
      };
      setSummaryEntries([...summaryEntries, newEntry]);
      form.setFieldsValue({
        shortage: undefined,
        overage: undefined,
        reason: undefined,
      });
    }
  };

  const summaryColumns = [
    { title: "Currency", dataIndex: "currencySummary", key: "currencySummary" },
    { title: "Shortage", dataIndex: "shortage", key: "shortage" },
    { title: "Overage", dataIndex: "overage", key: "overage" },
    { title: "Reason", dataIndex: "reason", key: "reason" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          className="of-primaryBtnColor"
          icon={<DeleteOutlined />}
          onClick={() => setSummaryEntries(summaryEntries.filter((e) => e.key !== record.key))}
        />
      ),
    },
  ];

  return (
    <>
      {/* <Divider /> */}
      <Form form={form} style={{ marginTop: 48 }} layout="vertical" onFinish={handleAddSummary}>
        <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
          <Col span={6}>
            <Form.Item
              name="currencySummary"
              label={<Text strong>Currency</Text>}
              rules={[
                {
                  required: true,
                  message: "Currency is required",
                },
              ]}
            >
              <Select
                style={{ width: "100%", height: 44 }}
                options={currencyOptions}
                placeholder="Select currency"
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="shortage"
              label={<Text strong>Shortage</Text>}
              rules={[
                {
                  required: true,
                  message: "Shortage is required",
                },
              ]}
            >
              <InputNumber style={{ width: "100%", height: 44, paddingTop: 6 }} min={0} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="overage"
              label={<Text strong>Overage</Text>}
              rules={[
                {
                  required: true,
                  message: "Overage is required",
                },
              ]}
            >
              <InputNumber style={{ width: "100%", height: 44, paddingTop: 6 }} min={0} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="reason"
              label={<Text strong>Reason</Text>}
              rules={[
                {
                  required: true,
                  message: "Reason is required",
                },
              ]}
            >
              <Input style={{ width: "100%", height: 44 }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            {/* <Form.Item label=" "> */}
            <Button
              type="primary"
              className="of-primaryBtnColor"
              style={{ height: 44 }}
              onClick={handleAddSummary}
            >
              Add
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </Form>

      <Table
        style={{ marginTop: 16, marginBottom: 24 }}
        dataSource={summaryEntries}
        columns={summaryColumns}
        pagination={false}
        size="small"
      />
    </>
  );
}
